export default __webpack_public_path__ + "static/media/client5.5a41a7bb.png";